import Decimal from 'decimal.js';

const VAT_RATE = 19;
export const calculateBrutto = (price: number, usesVat: boolean): number => {
  if (!usesVat) {
    return price;
  }
  const nettoDec = new Decimal(price);
  const taxRate = new Decimal(VAT_RATE).div(100);

  const brutto = nettoDec
    .mul(new Decimal(1).plus(taxRate))
    .toDecimalPlaces(2, Decimal.ROUND_HALF_UP);
  return brutto.toNumber();
};
